import React from "react";
import styled from "styled-components";
import IncisivoSelect from "../../../components/Dientes/IncisivoSelect";
import MolarSelect from "../../../components/Dientes/MolarSelect";
import PremolarSelect from "../../../components/Dientes/PremolarSelect";
import Diente from "../../../components/Diente";
import { Puente } from "../../../components/Puente";
import { Denticion, DefaultConfig } from "../../../components/ConfigDiente";
import { useDispatch } from "react-redux";
import { updateSesionLocal } from "../../../redux/atenciones/atencionesActions";

const Container = styled.div`
    margin-top: 15px;
    padding: 20px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #e0e0e0;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
`;

const Title = styled.div`
    font-size: 0.85rem;
    color: #4a4a4a;
    margin-bottom: 15px;
    font-weight: 600;
    text-align: center;
    letter-spacing: 0.5px;
`;

const DienteBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 10px;
`;

export const OdontoExecution = ({ item, sesionBridge, onUpdateExecution, disabled }) => {
    const dispatch = useDispatch();
    const { grupo, afectaOdonto, coronaTipo } = item.config;
    const [faces, setFaces] = React.useState(sesionBridge?.caras || []);
    const [pilares, setPilares] = React.useState(sesionBridge?.pilares || []);

    React.useEffect(() => {
        if (sesionBridge) {
            setFaces(sesionBridge.caras || []);
            setPilares(sesionBridge.pilares || []);
        }
    }, [sesionBridge]);

    if (!afectaOdonto) return null;

    const handleUpdate = (data) => {
        if (disabled) return;
        onUpdateExecution(data);
        if (sesionBridge) {
            dispatch(updateSesionLocal(sesionBridge.id, data));
        }
    };

    const handleSelectedFaces = (e) => {
        if (disabled) return;
        const property = e.target.id;
        let myfaces = [...faces];
        let idx = myfaces.findIndex((it) => it == property);
        if (idx > -1) {
            myfaces.splice(idx, 1);
        } else myfaces.push(property);
        setFaces(myfaces);
        handleUpdate({ caras: myfaces });
    };

    const handleCheckPilar = (e) => {
        if (disabled) return;
        let dienteId = e.target.id;
        let mypilares = [...pilares];
        if (e.target.checked) {
            mypilares.push(dienteId);
        } else {
            mypilares = mypilares.filter((d) => d != dienteId);
        }
        setPilares(mypilares);
        handleUpdate({ pilares: mypilares });
    };

    const isPilar = (id) => pilares.some((d) => d == id);

    const renderToothSelector = (dienteId) => {
        const nombre = Denticion.getNombre(dienteId);
        const configMock = { color: item.config.color || "blue" };

        if (nombre.includes("molar") && !nombre.includes("premolar")) {
            return (
                <MolarSelect
                    faces={faces}
                    onSelectedFace={handleSelectedFaces}
                    color={configMock.color}
                />
            );
        } else if (nombre.includes("premolar")) {
            return (
                <PremolarSelect
                    faces={faces}
                    onSelectedFace={handleSelectedFaces}
                    color={configMock.color}
                />
            );
        } else {
            return (
                <IncisivoSelect
                    faces={faces}
                    onSelectedFace={handleSelectedFaces}
                    color={configMock.color}
                />
            );
        }
    };

    const itemsOdontograma = (item.dientes || []).map(d => new DefaultConfig(d));

    return (
        <Container style={{ opacity: disabled ? 0.7 : 1, pointerEvents: disabled ? 'none' : 'auto' }}>
            <Title>{disabled ? "REGISTRO CLÍNICO (COMPLETADO)" : "ESTADO CLÍNICO DEL DIENTE"}</Title>
            <DienteBox>
                {grupo === "CARAS" && item.dientes?.length > 0 && (
                    <div style={{ transform: 'scale(1.4)', margin: '30px 0' }}>
                        {renderToothSelector(item.dientes[0])}
                        <div style={{ textAlign: 'center', fontSize: '1rem', marginTop: '10px', fontWeight: 'bold', color: disabled ? '#6c757d' : '#0c8de3' }}>
                            Diente {item.dientes[0]}
                        </div>
                    </div>
                )}

                {(coronaTipo === "PUENTE" || coronaTipo === "PROTESIS_REMOVIBLE") && (
                    <div style={{ transform: 'scale(1.2)' }}>
                        <Puente
                            itemsOdontograma={itemsOdontograma}
                            pilares={pilares}
                            config={item.config}
                            onCheck={handleCheckPilar}
                            getValue={isPilar}
                        />
                    </div>
                )}

                {grupo !== "CARAS" && coronaTipo !== "PUENTE" && coronaTipo !== "PROTESIS_REMOVIBLE" && (
                    <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', justifyContent: 'center', transform: 'scale(1.3)' }}>
                        {item.dientes?.map(d => (
                            <div key={d} style={{ textAlign: 'center' }}>
                                <Diente numero={d} config={new DefaultConfig(d)} />
                                <div style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>{d}</div>
                            </div>
                        ))}
                    </div>
                )}
            </DienteBox>
        </Container>
    );
};
